import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faGlobe, faLink, faShareAlt, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SharingIndicators',
    props: {
        object: null
    },
    setup(__props) {
        const props = __props;
        library.add(faGlobe, faShareAlt, faLink, faUsers);
        return { __sfc: true, props, FontAwesomeIcon, BButton };
    }
});
